import Maybe from "components/elements/maybe";
import { useOwnTranslate } from "lib/hooks/useOwnTranslate";
import { useState } from "react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import useHPIDetail from "../hooks/useHPIDetail";
import HousePricesDetailLink from "./housePricesDetailLink";




const HousePricesDetailLinks = () => {
  const { t } = useOwnTranslate('');
  const { sideLinks } = useHPIDetail({city:undefined,region:undefined});
  const [isOpen, setIsOpen] = useState(false);
  if (!(sideLinks && sideLinks.bigAreaRelated)) return null;
  return (
    <>
      <div className="px-2">
        <h4 className="font-semibold text-primary-600 text-display-xs mb-8">
          {t('global.relatedToYourSearch')}
        </h4>
        {sideLinks?.bigAreaRelated.slice(0, 5).map((item) => (
          <HousePricesDetailLink
            key={item.url}
            {...item}
          ></HousePricesDetailLink>
        ))}
        <Maybe condition={isOpen}>
          {sideLinks?.bigAreaRelated.slice(5).map((item) => (
            <HousePricesDetailLink
              key={item.url}
              {...item}
            ></HousePricesDetailLink>
          ))}
        </Maybe>

        <button
          className="text-primary-700 mt-6 inline-flex items-center gap-2"
          onClick={() => setIsOpen((state) => !state)}
        >
          <span>{isOpen ? t('global.showLess') : t('global.showMore')}</span>
          {isOpen ? (
            <FaAngleUp />
          ) : (
            <FaAngleDown direction={'down'} />
          )}
        </button>

        <hr className="mt-4" />
      </div>
    </>
  );
};

export default HousePricesDetailLinks;
